import { useState } from 'react';
import CampoArea from '@/components/base/CampoArea';

interface Props {
  aoConfirmar: (motivo: string) => void;
  aoCancelar: () => void;
  salvando: boolean;
  /** Erro vindo do servidor (ex.: o estorno falhou). Aparece acima do botão. */
  erroExterno?: string | null;
  /** Chamado quando o usuário edita um campo, para limpar o erro do servidor. */
  aoLimparErro?: () => void;
}

export default function FormEstornarPagamento({
  aoConfirmar,
  aoCancelar,
  salvando,
  erroExterno,
  aoLimparErro,
}: Props) {
  const [motivo, setMotivo] = useState('');
  const [erro, setErro] = useState<string | null>(null);
  const erroMostrado = erro || erroExterno || null;

  function limpar() {
    setErro(null);
    aoLimparErro?.();
  }

  function enviar() {
    if (!motivo.trim()) {
      setErro('Informe o motivo do estorno.');
      return;
    }
    setErro(null);
    aoConfirmar(motivo.trim());
  }

  return (
    <div className="fixed inset-0 z-[60] flex items-end justify-center bg-black/30 sm:items-center sm:p-6">
      <div className="animate-modal-pop max-h-[90vh] w-full overflow-y-auto rounded-t-lg bg-white sm:max-w-md sm:rounded-lg">
        <div className="flex items-center justify-between border-b border-secondary-100 px-5 py-4">
          <h3 className="text-lg font-medium text-foreground-950">Estornar pagamento</h3>
          <button
            type="button"
            onClick={aoCancelar}
            className="flex h-8 w-8 cursor-pointer items-center justify-center rounded-full text-secondary-500 hover:bg-background-100"
          >
            <i className="ri-close-line text-xl" />
          </button>
        </div>

        <div className="space-y-5 px-5 py-5">
          <CampoArea
            id="estorno-motivo"
            name="estorno_motivo"
            label="Motivo"
            help="Obrigatório. Ex.: pagamento registrado por engano, valor incorreto."
            value={motivo}
            onChange={(v) => {
              setMotivo(v);
              limpar();
            }}
            required
            maxLength={500}
            simples
          />
        </div>

        {erroMostrado && (
          <p className="px-5 pb-3 text-sm font-medium text-danger-600" role="alert">
            {erroMostrado}
          </p>
        )}

        <div className="flex gap-3 border-t border-secondary-100 px-5 py-4">
          <button
            type="button"
            onClick={aoCancelar}
            className="flex-1 cursor-pointer whitespace-nowrap rounded-md border border-secondary-300 bg-white px-4 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100"
          >
            Cancelar
          </button>
          <button
            type="button"
            onClick={enviar}
            disabled={salvando}
            className="flex-1 cursor-pointer whitespace-nowrap rounded-md bg-danger-600 px-4 py-2.5 text-sm font-medium text-white transition-colors hover:bg-danger-700 disabled:opacity-60"
          >
            {salvando ? 'Estornando…' : 'Estornar'}
          </button>
        </div>
      </div>
    </div>
  );
}